<template>
  <v-navigation-drawer id="app-drawer" app permanent stateless disable-resize-watcher disable-route-watcher width="260">
    <div class="logo">
      <v-img src="@/assets/logo.svg" />
    </div>
    <div class="add-btn">
      <Registration />
    </div>
    <v-list flat>
      <v-list-item-group>
        <v-list-item
          id="linkToSubscribers"
          :to="item.url"
          @click="clickMenuHandler(item.title)"
          v-for="item in currentMenu"
          :key="item.title"
        >
          <v-list-item-icon>
            <v-icon large text>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title text>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import role from '../../services/userRoles'
import Registration from '../../views/Registration'

export default {
  name: 'Sidebar',
  data: () => ({
    currentMenu: []
  }),
  components: { Registration },
  watch: {
    userRole(value) {
      if (value) this.currentMenu = role().getMenu()
    }
  },
  computed: {
    userRole() {
      return this.$store.state.user.role
    }
  },
  methods: {
    clickMenuHandler(title) {
      this.$store.commit('SAVE_NAV_TITLE', title)
    }
  }
}
</script>

<style lang="scss" scoped>
#app-drawer {
  .logo {
    padding: 40px 24px;
  }
  .add-btn {
    text-align: center;
    margin-bottom: 32px;
    padding: 0 32px;
  }
  .v-list {
    font-size: 12px;
    &-item {
      padding: 0 32px;
      &__icon {
        margin-right: 18px;
      }
      &--active {
        border-right: 4px solid #007aff;
        background: #eff5fe;
        .v-list-item__content {
          color: #007aff;
          font-weight: 700;
        }
      }
      &-group {
        color: #007aff;
      }
    }
  }
}
</style>
